export default {
  title01: "Anlık Hava Durumu",
  title02: "24 Saat",
  title03: "10 Günlük Hava Durumunu Görüntüle",
  title04: "Hava Kalitesi İndeksi",
  title05: "Bütün Bilgileri Görüntüle",
  title06: "GÜN DOĞUMU VE GÜN BATIMI",
  title07: "AYIN DÖNGÜLERİ",
  title08: " Bir Sonraki Dolunay",
  title09: "Bir Sonraki Yeni Ay",
  title10: "GÜN",
  title11: "GECE",
  title12: "Gün Doğumu",
  title13: "Gün Batımı",
  title14: "Ay Doğumu",
  title15: "Ay Batımı",
  title16: "Kaynak",
  title17: "Başlangıç",
  title18: "Bitiş",
  title19: "Anlık Konumu Kullan",
  title20: "Şehir Ara",
  title21: "Hissedilen sıcaklık",
  title22: "Hissedilen sıcaklık (gölgede)",
  title23: "Şu anda",
  title24: "Bugün",
  title25: "PZR",
  title26: "PZRT",
  title27: "SALI",
  title28: "ÇRŞ",
  title29: "PRŞ",
  title30: "CUMA",
  title31: "CMRT",
  title32: "Yükleniyor...",
  title33: "Şu anda",
  title34: "Saatlik",
  title35: "Günlük",
  title36: "Güneş ve Ay",
  title37: "Hava Kalitesi",
  title38: "İletişim İçin: xlf550402@gmail.com",
  title39: "Gizlilik Politikası'",
  title40: "Copyright © comfortweather.com 2020 - 2026. Her hakkı saklıdır.",
  title41: "",
  title42: "Tmax",
  title43: "Tmin",
  title44: "Kabul",
  title45:
    "ComfortWeather'ı kullandığınız için teşekkür ederiz. Yasal haklarınızı ve kişisel bilgilerinizi daha iyi koruyabilmek adına, lütfen ",
  title46: "Gizlilik Politikası'",
  title47: " nı dikkatlice okuyunuz.",
  title48: "tarafından veriler sağlanmıştır.",
  title49: "İletişim İçin: xyjph123@gmail.com",
  title50: "Copyright © 24hweather.com 2020 - 2026. Her hakkı saklıdır.",
  title51:
    "24hweather'ı kullandığınız için teşekkür ederiz. Yasal haklarınızı ve kişisel bilgilerinizi daha iyi koruyabilmek adına, lütfen ",
  title52: "Konumunuz değişmiştir. Güncellemek ister misiniz?",
  title53: "Onayla ",
  title54: "İptal",
  title55: "Geri",
  title56: "Haberler",
  title57: "Hava Durumu Güncelleniyor...",
  title58: "Hava Durumu Güncellendi",
  title59: "Tümünü Görüntüle",
  title60: "Copyright © mobi321.com 2020 - 2026. Her hakkı saklıdır.",
  title61: "Dün",
  title62: "Yarın",
  title63: "15 Günlük Hava Durumunu Görüntüle",
  title64: "Bugünün Detayları",
  title65: "Rahu Kaal",
  title66: "Hava Durumu ve Yaşam",
  title67: "Hava Durumu ve Yaşam",
  title68: "未来7天Rahu Kala时间表",
  title69: "至",
  title70: "至",
  title71: "空气质量指数",

  title102: "Zor kuruma",
  title103: "Yavaş kuruma",
  title104: "Normal kuruma",
  title105: "Hızlı kuruma",
  title106: "Çok hızlı kuruma",

  title107: "Uygun değil",
  title108: "Orta düzey",
  title109: "Su eğlencesi için uygun",
  title110: "Çok uygun",
  title111: "Mükemmel zamanlama",

  title112: "Sağlıklı hava koşulları",
  title113: "Dengeli koşullar",
  title114: "Biraz daha yüksek risk",
  title115: "Yüksek risk",
  title116: "Çok yüksek risk",

  title117: "Uygun Değil",
  title118: "Biraz Uygun",
  title119: "Uygun",
  title120: "Çok uygun",
  title121: "Mükemmel derecede uygun",

  title122: "Aşırı kuru hava koşulları",
  title123: "Kuru olması muhtemel",
  title124: "Hafif kuru hava",
  title125: "Kuru olma olasılığı düşük",
  title126: "Kuru olma ihtimali çok zayıf",

  title127: "Önerilmez",
  title128: "Kabul edilebilir",
  title129: "İyi zamanlama",
  title130: "Çok iyi zamanlama",
  title131: "En ideal zamanlama",
};
